import { get, invert } from 'lodash';
import { invokeEvent } from 'shared-base';
import { discountMapping, paddingMapping } from './globals';

export const priceIdToProductId = (priceId: string): ProductId | undefined => {
  try {
    return invert(paddingMapping)[priceId] as ProductId;
  } catch (err) {
    invokeEvent('sentry', { err });
  }
};

export const analyzeCheckoutData = (data: PaddleCheckoutData): ProductId | undefined => {
  try {
    const firstPrice = get(data, 'data.items[0].price_id');
    if (!firstPrice) return;
    return priceIdToProductId(firstPrice);
  } catch (err) {
    invokeEvent('sentry', { err });
  }
};

export const fixDiscounts = (isEmployee: boolean) => {
  const map = discountMapping as any;

  if (!isEmployee) return;

  if (map.MONTH_POPULAR_emp) { map.MONTH_POPULAR = map.MONTH_POPULAR_emp; } // prettier-ignore
  if (map.CREDITS_10_emp) { map.CREDITS_10 = map.CREDITS_10_emp; } // prettier-ignore
};
